import './styles.css';

import LinearProgress from '@material-ui/core/LinearProgress';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const Progress: React.FC<any> = ({ loading }) => {
  const [progress, setProgress] = useState(0);
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    let interval: any;
    if (loading.qtdRequestLoading) {
      interval = setInterval(() => {
        setProgress(v => v + 1);
        setDisplay(true);
      }, 100);
    } else {
      setProgress(100);

      setProgress(0);
      setDisplay(false);
    }
    return () => clearInterval(interval);
  }, [loading]);

  return (
    display && (
      <div className="progress-root">
        <LinearProgress className="progress" variant="determinate" value={progress} />
      </div>
    )
  );
};

const mapStateToProps = (state: any) => {
  return {
    loading: state.loading
  };
};

export default connect(mapStateToProps)(Progress);
